<template>
<div class="p">
  <div class="exhibition">
    <div class="exhibition-title">
      ***市***区教育局-教育云
    </div>
    <div v-if="fullScreenShow" class="exhibition__out" @click="handleOpen"></div>
    <div v-else  class="exhibition__shrink" @click="exitScreen"></div>
    <div class="exhibition-content">
      <div class="exhibition-content__branch">
        <information-education v-if="Number(activeId) === 1" />
        <resource-allocation v-if="Number(activeId) === 2" />
        <SchoolBigData v-if="Number(activeId) === 3" />
      </div>
      <div class="exhibition-content__bottom pointer">
        <div :class="{'is-active': Number(activeId) === 1}" @click="changeResource(1)">教育信息化建设</div>
        <div :class="{'is-active': Number(activeId) === 2}" @click="changeResource(2)">教育资源配置</div>
        <div :class="{'is-active': Number(activeId) === 3}" @click="changeResource(3)">教育大数据</div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InformationEducation from './components/information-education.vue';
import ResourceAllocation from './components/resource-allocation.vue';
import SchoolBigData from './components/school-big-data.vue';

export default {
  name: 'Exhibition',
  components: {
    InformationEducation,
    ResourceAllocation,
    SchoolBigData,
  },
  data() {
    return {
      activeId: 1,
      fullScreenShow: true,
    };
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      setTimeout(() => {
        if (!that.fullscreenElement()) {
          that.exitScreen();
        }
      });
    };
  },
  methods: {
    changeResource(id) {
      this.activeId = id;
    },
    fullscreenElement() {
      const fullscreenEle = document.fullscreenElement || document.mozFullScreenElement
       || document.webkitFullscreenElement;
      return fullscreenEle;
    },
    handleOpen() {
      const el = document.documentElement;
      const rfs = el.requestFullScreen
      || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullscreen;
      if (typeof rfs !== 'undefined' && rfs) {
        rfs.call(el);
      }
      this.isshow = false;
      this.fullScreenShow = false;
    },
    exitScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
      this.isshow = true;
      this.fullScreenShow = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.p {
  width: 100%;
  height: 100%;
  overflow: auto;
}
  .exhibition {
    position: relative;
    width: 1920px;
    height: 1080px;
    display: flex;
    overflow: auto;
    flex-direction: column;
    background: url('../images/exhibition-bg.jpg') no-repeat center / 100% 100%;
    &-title {
      width: 100%;
      height: 80px;
      color: #fff;
      line-height: 62px;
      text-align: center;
      font-size: 28px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #F5F5FF;
      background: url('../images/exhibition-title_bg.png') no-repeat center / 100% 100%;
    }
    &-content {
      position: relative;
      margin-bottom: 32px;
      padding: 0 20px;
      flex: 1;
      &__branch {
        width: 100%;
        height: 100%;
      }
      &__bottom {
        position: absolute;
        display: flex;
        width: 523px;
        height: 40px;
        line-height: 40px;
        left: 50%;
        font-size: 20px;
        bottom: 25px;
        color: #F5F5FF;
        transform: translateX(-50%);
        background: linear-gradient(180deg, rgba(90, 79, 255, 0.65) 0%,
        rgba(51, 131, 255, 0.44) 100%);
        box-shadow: 0px 4px 7px 0px rgba(119, 10, 235, 0.5);
        border-radius: 10px;
        border: 1px solid #770AEB;
        div {
          width: 33.5%;
          text-align: center;
        }
      }
      .is-active {
        background: url('../images/exhibition-tab_pitchOn.png') no-repeat left top / 100% 100%;
        line-height: 56px;
        color: #00FFFF;
        height: 55px;
        top: -8px;
        position: relative
      }
    }
    &__out {
        position: absolute;
        width: 40px;
        height: 40px;
        right: 80px;
        top: 15px;
        margin-left: 30px;
        background: url('../images/full-screen.png') no-repeat top left / cover;
      }
      &__shrink {
        position: absolute;
        width: 40px;
        height: 40px;
        top: 15px;
        right: 80px;
        margin-left: 50px;
        background: url('../images/shrink.png') no-repeat top left / cover;
      }
  }
</style>
